import React from 'react';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { PUBLICATION_STATUS } from 'constants/constants';
import messages from './messages';

import {
  PublishStatusStyle,
  PublishStatusCircle,
  HollowCircle,
  MarketsTooltip,
  MarketsTooltipRow,
  MarketsTooltipName,
  MarketsTooltipStatus,
  MarketsTooltipDot,
} from './styles';

const PublishStatusIcon = ({
  activity,
  theme,
}) => {
  let publicationDetails = activity?.publicationDetails;
  const allMarkets = [];
  let marketsExist = false;
  if (Array.isArray(publicationDetails)) {
    let indexToUseForStatus = 0;
    marketsExist = publicationDetails.some(
      (detail) => detail.publicationOutputType?.split(':')?.length > 1,
    );
    if (marketsExist) {
      publicationDetails.forEach((detail) => {
        allMarkets.push({ marketName: detail.publicationOutputType?.split(':')[1] ?? '', marketStatus: detail.oculusStatus });
      });
    }

    const publishedLiveIndex = publicationDetails.findIndex(
      (detail) => detail.oculusStatus === PUBLICATION_STATUS.PUBLISHED_LIVE,
    );
    indexToUseForStatus = publishedLiveIndex === -1 ? 0 : publishedLiveIndex;
    publicationDetails = publicationDetails[indexToUseForStatus];
  }
  if (!publicationDetails) {
    return <></>;
  }
  const currentStatus = publicationDetails.oculusStatus;
  if (!currentStatus) {
    return (
      <HollowCircle>
        <PublishStatusStyle>Status Unknown</PublishStatusStyle>
      </HollowCircle>
    );
  }

  const marketStatusLabel = (status) =>
    status === PUBLICATION_STATUS.PUBLISHED_LIVE
      ? intl.formatMessage(messages.publishedLive)
      : intl.formatMessage(messages.inReview);

  const marketStatusColor = (status) =>
    status === PUBLICATION_STATUS.PUBLISHED_LIVE
      ? theme['color.green']
      : theme['color.magenta'];

  const renderMarkets = () => {
    if (!marketsExist || allMarkets.length === 0) {
      return null;
    }
    return (
      <MarketsTooltip role="tooltip">
        {allMarkets.map((m, i) => (
          <MarketsTooltipRow key={`${m.marketName}-${i}`}>
            <MarketsTooltipName title={m.marketName}>
              {m.marketName}
            </MarketsTooltipName>
            <MarketsTooltipStatus>
              <MarketsTooltipDot $color={marketStatusColor(m.marketStatus)} />
              <span>{marketStatusLabel(m.marketStatus)}</span>
            </MarketsTooltipStatus>
          </MarketsTooltipRow>
        ))}
      </MarketsTooltip>
    );
  };

  const renderStatus = (color, label) => (
    <PublishStatusCircle color={color} marketsExist={marketsExist}>
      <PublishStatusStyle>{label}{renderMarkets()}</PublishStatusStyle>
    </PublishStatusCircle>
  );
  switch (currentStatus) {
    case PUBLICATION_STATUS.IN_REVIEW:
      return renderStatus(
        theme['color.magenta'],
        intl.formatMessage(
          marketsExist ? messages.marketsInReview : messages.inReview,
        ),
      );
    case PUBLICATION_STATUS.PUBLISHED_LIVE:
      return renderStatus(
        theme['color.green'],
        intl.formatMessage(
          marketsExist ? messages.marketsLive : messages.publishedLive,
        ),
      );
    default:
      return null;
  }
};

export default PublishStatusIcon;
